import BasePage from './BasePage';
import { connect } from 'react-redux';
import configData from "../config.json";
import { setModalContent } from '../actionCreators';
import Menu from '../components/Menu';
import Modal from '../components/Modal';
import Table from '../components/Table';
import Seeker from '../components/Seeker';
import $ from 'jquery';

class Articles extends BasePage {

	loadOnConstructor() {
		this.getArticles = this.getArticles.bind(this);
		this.newArticle = this.newArticle.bind(this);
		this.deleteClick = this.deleteClick.bind(this);
		this.deleteArticle = this.deleteArticle.bind(this);
		this.deleteArticleCallback = this.deleteArticleCallback.bind(this);
		this.clickPaginationCallback = this.clickPaginationCallback.bind(this);
		this.parseArticleResponse = this.parseArticleResponse.bind(this);
		this.excelExport = this.excelExport.bind(this);
		this.changeSeekerContent = this.changeSeekerContent.bind(this);
		this.handleSeekerChange = this.handleSeekerChange.bind(this);
		this.searchCallback = this.searchCallback.bind(this);
		this.QRScan = this.QRScan.bind(this);

		let startDate = new Date();
		let endDate = new Date();
		startDate.setDate(1);
		startDate.setHours(0);
		startDate.setMinutes(0);
		startDate.setSeconds(0);

		endDate.setMonth(endDate.getMonth() + 1);
		endDate.setDate(0);
		endDate.setHours(23);
		endDate.setMinutes(59);
		endDate.setSeconds(59);

		this.state = {
			canCreateArticle: false,
			startDate,
			endDate
		};

		this.getArticles('interface');
	}

	getArticles(type) {

		const api = this.getApi();
		let apiParams = [
			{ name: 'page', value: this.state.page ? this.state.page : 1 },
			{ name: 'limit', value: configData.rowsPerPage }
		];

		if (this.state.searchParams) {
			apiParams = apiParams.concat(this.state.searchParams);
		}

		if (type === 'interface') {
			api.getArticlesInterface(apiParams, this.parseArticleResponse);
		} else if (type === 'download') {
			apiParams.push({ name: 'export_to_file', value: 1 });
			api.downloadArticles(apiParams, this.parseArticleResponse);
		} else {
			api.getArticles(apiParams, this.parseArticleResponse);
		}
	}

	handleSeekerChange(event, previousSearchValue) {

		const api = this.getApi();
		let params = [];

		['name_like', 'lastname_like', 'email_like'].map(p => {
			return params.push({ name: p, value: event.target.value });
		});
		params.push({ name: 'conditions_type', value: 'or' });
		this.changeSeekerContent(params);

		const aditionalParams = [
			{ name: 'page', value: this.state.page ? this.state.page : 1 },
			{ name: 'limit', value: configData.rowsPerPage }
		];

		params = params.concat(aditionalParams);
		if (previousSearchValue !== event.target.value) {
			params = params.map(elem => {
				if (elem.name === 'page') elem.value = 1;
				return elem;
			});
		}

		api.getArticles(params, this.searchCallback);
	}

	changeSeekerContent(newSearchParams) {
		this.setState(prevState => {
			return {
				...prevState,
				searchParams: newSearchParams
			}
		});
	}

	QRScan(){
		window.ReactNativeWebView?.postMessage(JSON.stringify({QRScan: true}));
	}

	excelExport() {
		this.setState(prevState => {
			return {
				...prevState,
				download: true
			}
		}, this.getArticles.bind(this, 'download'));
	}

	parseArticleResponse(response) {
		if (response.status === 'OK') {

			this.setState(prevState => {
				return {
					...prevState,
					totalItems: response.totalItems,
					totalPages: response.totalPages,
					currentPage: response.currentPage,
					articles: response.articles,
					canCreateArticle: response.canCreateArticle,
					i18n: response.i18n
				}
			});

		} else if (this.state.download) {//Es download
			this.setState(prevState => {
				return {
					...prevState,
					download: 0
				}
			});

			const newBlob = new Blob([response], { type: 'application/octet-stream' });

			if (window.navigator && window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(newBlob);
			} else {
				// For other browsers: create a link pointing to the ObjectURL containing the blob.
				const objUrl = window.URL.createObjectURL(newBlob);

				let link = document.createElement('a');
				link.href = objUrl;
				link.download = "Articulos.xlsx";
				link.click();

				// For Firefox it is necessary to delay revoking the ObjectURL.
				setTimeout(() => { window.URL.revokeObjectURL(objUrl); }, 1000);
			}
		} else if (response.auth === false) {
			this.navigateTo('/login');
		}
	}

	newArticle() {
		this.navigateTo('/edit_article');
	}

	clickPaginationCallback(pageNumber) {
		this.setState(prevState => {
			return {
				...prevState,
				page: pageNumber
			}
		}, this.getArticles);
	}

	deleteClick(event) {

		this.props.setModalContent({
			title: this.getTrad('confirmAction'),
			body: [this.getTrad('doYouWantToDeleteArticle')],
			buttons: [
				{ shown: 'Aceptar', close: true, behaviour: 'main', callback: this.deleteArticle.bind(this, event.target.id) },
				{ shown: 'Cancelar', behaviour: 'secondary', close: true }
			]
		});

		$("#exampleModal").modal('toggle');
	}

	deleteArticle(buttonName) {
		const parts = buttonName.split('_');

		this.setState(prevState => {
			return {
				...prevState,
				deletedArticle: parts[1]
			}
		});
		const api = this.getApi();
		api.deleteArticle(parts[1], this.deleteArticleCallback);
	}

	deleteArticleCallback(response) {

		if (response && response.status === 'OK') {

			const articles = this.state.articles.filter(article => { return article._id !== this.state.deletedArticle });

			this.setState(prevState => {
				return {
					...prevState,
					articles
				}
			});
			setTimeout(() => {
				this.props.setModalContent({
					title: this.getTrad('messageFromServer'),
					body: [this.getTrad('articleDeletedSuccessfully')],
					buttons: [
						{ shown: 'Cerrar', close: true, behaviour: 'main' }
					]
				});

				$("#exampleModal").modal('toggle');
			}, 500);
		} else {
			setTimeout(() => {
				this.props.setModalContent({
					title: this.getTrad('messageFromServer'),
					body: [this.getTrad(response.message)],
					buttons: [
						{ shown: 'Cerrar', close: true, behaviour: 'main' }
					]
				});

				$("#exampleModal").modal('toggle');
			}, 500);
		}
	}

	parseDateToString(date) {
		const hoursFromTimezoneOffset = (date.getTimezoneOffset() * -1) / 60;
		let dateToString = new Date(date.getTime());
		dateToString.setHours(date.getHours() + hoursFromTimezoneOffset);

		return dateToString.getUTCFullYear() + "-" +
			("0" + (dateToString.getUTCMonth() + 1)).slice(-2) + "-" +
			("0" + dateToString.getUTCDate()).slice(-2) + " " +
			("0" + dateToString.getUTCHours()).slice(-2) + ":" +
			("0" + dateToString.getUTCMinutes()).slice(-2) + ":" +
			("0" + dateToString.getUTCSeconds()).slice(-2);
	}

	searchCallback(response) {
		//this.props.setUsers(response.users);
		this.setState(prevState => {
			return {
				...prevState,
				articles: response.articles,
				totalItems: response.totalItems,
				totalPages: response.totalPages,
				currentPage: response.currentPage
			}
		});

	}

	render() {
		return (
			<div className="container">
				<Menu />
				<h3>{this.getTrad('ArticlesAdmin')}</h3>
				{this.isMobileApp()? 
				<div className="row mb-2 mt-4">
					<div className="col-12">
						<button type="button" className="btn btn-primary btn-lg btn-block" onClick={this.QRScan}>
							Escanear QR
						</button>
					</div>
				</div> : ''}
				<div className="row mb-2 mt-4">
					<div className="col-4">
						{this.state.canCreateArticle ? <button type="button" className="btn btn-primary" onClick={this.newArticle}>
							{this.getTrad('NewArticle')}
						</button> : ''}
					</div>
					<div className="col-4">
						<button className="btn btn-secondary" onClick={this.excelExport}>Exportar a excel</button>
					</div>
					<div className="col-4 text-right">
						<Seeker
							config={{
								shown: 'name',
								setHandler: this.searchCallback,
								items: this.state.articles,
								handleChangeCallback: this.handleSeekerChange
							}}
						/>

					</div>
				</div>
				<div className="row">
					<div className="col-12">
						<Table
							config={{
								items: this.state.articles,
								i18n: this.state.i18n !== undefined ? this.state.i18n : [],
								mapping: [
									{
										original: 'name', shown: 'Nombre', visible: true, click: {
											url: '/edit_article', params: [{ name: 'article_id', field: '_id' }]
										}
									},
									{
										original: 'code', shown: this.getTrad("code"), visible: true, click: {
											url: '/edit_article', params: [{ name: 'article_id', field: '_id' }]
										}
									},
									{ original: '_id', shown: '_id', visible: false },
									{
										original: '_id', button: 'X', shown: 'Eliminar', visible: true, display: 'button',
										prefix: 'deletearticle_', click_callback: this.deleteClick
									}
								],
								pagination: {
									totalItems: this.state.totalItems ? this.state.totalItems : 0,
									totalPages: this.state.totalPages ? this.state.totalPages : 1,
									currentPage: this.state.currentPage ? this.state.currentPage : 1,
									callback: this.clickPaginationCallback
								}
							}}
						/>
					</div>
				</div>
				<Modal />
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		
	};
}

const mapDispatchToProps = dispatch => {
	return {
		setModalContent(modalContent) {
			dispatch(setModalContent(modalContent));
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Articles)
